/**
 * Created by Ning Jiang on 4/19/2016.
 */

import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {IBlankGameData} from "./IBlankServerData";
import {IBetLineWinData, IBetWinData, IServerData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {WGServerDataParser} from "../WGServerDataParser";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/core/utils/ArrayHelper";
import {ReelSymbolName} from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolName";

export class WGParsedGameData extends ParsedGameData {
    longestWin: number;
    doReelNudge: boolean[];
    extraSymbolsOnTop?: string[][];
    wildMultipliers: number[];
    triggerWarriorSymbol: string;
    triggerWarriorPay: boolean;
    activeWarriorSymbolReel: boolean[];
    actualReels: string[][];
    symbolWinStates: boolean[][];
    warriorMultiplier: number;
    nearWinReels: boolean[];
    superFreespin: boolean;
    lockedFSWildMultiplier: number[];
    lockedWildReelsAfter: boolean[];
    lockedWildReelsBefore: boolean[];

    WildReelPositions: number[];
    scatterReelPositions: number[];
    highLvlSymPositions: number[];
    warriorPayout: number;
    nearWinWarrior: boolean[] = [];
    nearWinBigWinReels: boolean[] = [];
    warriorBetLineWins: IBetLineWinData[] = [];
    _rawdata: IBlankGameData;
    accumulatedRoundWin:string;
    originalBetLinesData:IBetLineWinData[];

    constructor(rawData: IBlankGameData, dataParser: WGServerDataParser) {
        super(rawData, dataParser);
        this._rawdata = rawData;
        this.originalBetLinesData=JSON.parse(JSON.stringify(rawData.betLineWins));
        this.wildMultipliers = this.parsetWildMultipliers(rawData.wildMultipliers);
        this.doReelNudge = this.parseDoReelNudge(rawData.doReelNudge);
        this.extraSymbolsOnTop = this.parseExtraSymbolOnTop(rawData.extraSymbolsOnTop);
        this.triggerWarriorSymbol = this.parseTriggerWarriorSymbol(rawData.triggerWarriorSymbol);
        this.triggerWarriorPay = this.parseTriggerWarriorPay(rawData.triggerWarriorPay);
        this.activeWarriorSymbolReel = this.parseActiveWarriorSymbolReel(rawData.activeWarriorSymbolReel);
        this.actualReels = this.parseActualReels(rawData);
        this.warriorMultiplier = this.parseWarriorMultiplier(rawData.warriorMultiplier);
        this.parseSymbolWinStates(rawData);
        this.nearWinReels = this.parseNearWinReels(rawData);
        this.superFreespin = this.parseSuperFreespin(rawData.superFreespin);
        this.lockedFSWildMultiplier = this.parseLockedFSWildMultiplier(rawData.lockedFSWildMultiplier);
        this.lockedWildReelsAfter = this.parseLockedWildReelsAfter(rawData.lockedWildReelsAfter);
        this.lockedWildReelsBefore = this.parseLockedWildReelsBefore(rawData.lockedWildReelsBefore);
        this.warriorPayout = this.parseWarriorPayout(rawData.warriorPayout);

        this.scatterReelPositions = this.findOneSymbol(ReelSymbolName.SCATTER);
        this.WildReelPositions = this.findOneSymbol(ReelSymbolName.WILD);
        this.highLvlSymPositions = this.findOneSymbol("M");
        this.longestWin = this.calcLongestWin(rawData);
        this.nearWinWarrior = dataParser.parseNearWinWarrior(rawData);
        this.warriorBetLineWins = this.parseWarriorBetLineWins(rawData);
        this.nearWinBigWinReels = this.parsenearWinBigWinReels(rawData);
        this.accumulatedRoundWin = rawData.accumulatedRoundWin;
    }

    private parseWarriorBetLineWins(rawData: IBlankGameData): IBetLineWinData[] {
        return rawData.warriorBetLineWins;
    }

    private parsenearWinBigWinReels(rawdata: IBlankGameData): boolean[] {
        return rawdata.nearWinBigWinReels;
    }

    private calcLongestWin(rawdata: IBlankGameData): number {
        let temp: number = 0;
        for (let groups: number = 0; groups < rawdata.betLineWins!.length; groups++) {
            if (temp < rawdata.betLineWins![groups].nrOfSymbols) {
                temp = rawdata.betLineWins![groups].nrOfSymbols;
            }
        }
        return temp;
    }

    private findOneSymbol(symbol: string): number[] {
        let arr: number[] = [];

        for (let reel: number = 0; reel < this.reels.length; reel++) {
            let pos: number = -1;
            for (let row: number = 0; row < 3; row++) {
                if (this.reels[reel][row + 3].indexOf(symbol) >= 0) {
                    pos = row;
                    break;
                }
            }
            arr.push(pos);
        }
        return arr;
    }

    private parsetWildMultipliers(wildMultipliers: number[]): number[] {
        return wildMultipliers;
    }

    private parseDoReelNudge(doReelNudge: boolean[]): boolean[] {
        return doReelNudge;
    }

    private parseExtraSymbolOnTop(extraSymbolsOnTop: string[][] | undefined): string[][] | undefined {
        return extraSymbolsOnTop;

    }

    private parseTriggerWarriorSymbol(triggerWarriorSymbol: string): string {
        return triggerWarriorSymbol;
    }

    private parseTriggerWarriorPay(triggerWarriorPay: boolean): boolean {
        return triggerWarriorPay;
    }

    private parseActiveWarriorSymbolReel(activeWarriorSymbolReel: boolean[]): boolean[] {
        return activeWarriorSymbolReel;
    }

    private parseActualReels(rawData: IServerData): string[][] {
        return WGServerDataParser.parseStackedSymbolsInReels(rawData.reels, undefined, true);
    }

    /**
     * function to set symbol win state
     * calculating for nowinPresentation and controlling overlays dim state.
     * @param rawData
     */
    private parseSymbolWinStates(rawData: IServerData) {
        this.symbolWinStates = ArrayHelper.initArrayWithValues<boolean[]>(6, () => {
            return ArrayHelper.initArrayWithValues<boolean>(3, () => false)
        });
        this.betWins!.forEach((betLineWinData: IBetWinData) => {

            let betLineLength = (<IBetLineWinData>betLineWinData).nrOfSymbols;
            for (let reelId: number = 0; reelId < betLineLength; reelId++) {
                const symbolId: number = (<IBetLineWinData>betLineWinData).betLine[reelId];
                this.symbolWinStates[reelId][symbolId] = true;
            }
        });
    }

    private parseWarriorMultiplier(warriorMultiplier: number): number {
        return warriorMultiplier;
    }

    private parseSuperFreespin(superFreespin: boolean): boolean {
        return superFreespin;

    }

    private parseLockedFSWildMultiplier(lockedFSWildMultiplier: number[]): number[] {
        return lockedFSWildMultiplier;
    }

    /**
     * function to calculate near win reels in case of scatter anticipation, might remove it once done from server end
     * @param rawData
     */
    private parseNearWinReels(rawData: IBlankGameData): boolean[] {
        return rawData.nearWinReels;
    }

    private parseLockedWildReelsAfter(lockedWildReelsAfter: boolean[]): boolean[] {
        return lockedWildReelsAfter;
    }

    private parseLockedWildReelsBefore(lockedWildReelsBefore: boolean[]): boolean[] {
        return lockedWildReelsBefore;
    }

    private parseWarriorPayout(warriorPayout: number): number {
        return warriorPayout;
    }
}